/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_CollectiblesInputs */

const en_listing_category_collectibles = /** @type {(inputs: Listing_Category_CollectiblesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collectibles`)
};

const es_listing_category_collectibles = /** @type {(inputs: Listing_Category_CollectiblesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coleccionables`)
};

const fr_listing_category_collectibles = /** @type {(inputs: Listing_Category_CollectiblesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objets de collection`)
};

const de_listing_category_collectibles = /** @type {(inputs: Listing_Category_CollectiblesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammlerstücke`)
};

const ja_listing_category_collectibles = /** @type {(inputs: Listing_Category_CollectiblesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コレクション`)
};

const zh_listing_category_collectibles = /** @type {(inputs: Listing_Category_CollectiblesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收藏品`)
};

const ar_listing_category_collectibles = /** @type {(inputs: Listing_Category_CollectiblesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقتنيات`)
};

const id_listing_category_collectibles = /** @type {(inputs: Listing_Category_CollectiblesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barang Koleksi`)
};

const it_listing_category_collectibles = /** @type {(inputs: Listing_Category_CollectiblesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collezionismo`)
};

const ru_listing_category_collectibles = /** @type {(inputs: Listing_Category_CollectiblesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коллекционирование`)
};

const pt_listing_category_collectibles = /** @type {(inputs: Listing_Category_CollectiblesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colecionáveis`)
};

const ko_listing_category_collectibles = /** @type {(inputs: Listing_Category_CollectiblesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수집품`)
};

/**
* | output |
* | --- |
* | "Collectibles" |
*
* @param {Listing_Category_CollectiblesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_collectibles = /** @type {((inputs?: Listing_Category_CollectiblesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_CollectiblesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_collectibles(inputs)
	if (locale === "es") return es_listing_category_collectibles(inputs)
	if (locale === "fr") return fr_listing_category_collectibles(inputs)
	if (locale === "de") return de_listing_category_collectibles(inputs)
	if (locale === "ja") return ja_listing_category_collectibles(inputs)
	if (locale === "zh") return zh_listing_category_collectibles(inputs)
	if (locale === "ar") return ar_listing_category_collectibles(inputs)
	if (locale === "id") return id_listing_category_collectibles(inputs)
	if (locale === "it") return it_listing_category_collectibles(inputs)
	if (locale === "ru") return ru_listing_category_collectibles(inputs)
	if (locale === "pt") return pt_listing_category_collectibles(inputs)
	return ko_listing_category_collectibles(inputs)
});